import React, { useState } from "react";
import { DoctorRoomFormComponent } from "../../Components";
import { clanicData, convertNumber, convertTitle, errorMessage, successNotification } from "../../utils/helpers";
import axios from "axios";
import { POST } from "../../utils/apis";
import { CiEdit } from "react-icons/ci";
import { MdDelete } from "react-icons/md";
import { Button, Popconfirm, Spin, Table } from "antd";
import { useSelector } from "react-redux";

const DoctorRoomForm = (props) => {
    const { selectedLanguage, userActions, user } = props;
    const myRooms = useSelector(state => state?.userReducer?.allRooms)
    const myRoomsData = myRooms?.length ? myRooms : []
    const [showForms, setShowForms] = useState(false)
    const [spin, setSpin] = useState({})
    const [editData, setEditData] = useState({})
    console.log('=editData', editData)
    let columns = [
        {
            title: selectedLanguage?.txt_room_name,
            render: (e) => <p>{e?.roomName} </p>
        },
        {
            title: selectedLanguage?.service_heading,
            dataIndex: 'services',
            render: (e) => <span style={{
                display: 'flex',
                flexWrap: 'wrap',
                background: '#8080802b',
                borderRadius: 18,
                padding: 10,
                width: 220
            }}> {e?.length ?
                e?.map((v, i) => {
                    return (
                        <p className='content-form-tabel-chips'>{v?.serviceName}</p>
                    )
                }) :
                <p className='content-form-tabel-chips' style={{ width: '100%' }}>{selectedLanguage?.txt_not_added_services}</p>
                }
            </span>
        },
        {
            title: selectedLanguage?.txt_actions,
            render: (e) => <span>
                <CiEdit size={20}
                    onClick={() => {
                        setEditData(e);
                        setShowForms(false)
                    }}
                />
                &nbsp;
                &nbsp;
                <Popconfirm
                    title={`${selectedLanguage?.txt_delete} ${convertTitle(e?.roomName)}?`}
                    okText={selectedLanguage?.txt_delete}
                    cancelText={selectedLanguage?.txt_cancel}
                    okButtonProps={{
                        type: 'primary',
                        className: 'form-button'
                    }}
                    cancelButtonProps={{ style: { borderRadius: 4 } }}
                    onConfirm={() => {
                        deleteForm(e);
                    }}
                    disabled={spin[e?.url]}
                >
                    {spin[e?._id] ?
                        <Spin /> :
                        <MdDelete size={20} color="red" />}
                </Popconfirm>
            </span >
        },
    ]

    const deleteForm = (_id) => {
        setSpin({ [_id]: true })
        let deleteFormObj = {
            _id,
            clanicId: user?._id
        }
        axios.post(POST?.DELETE_ROOM, deleteFormObj)
            .then((res) => {
                const { data } = res
                if (data?.success) {
                    clanicData.getMyAllRooms(userActions, user?._id)
                    setSpin({})
                    successNotification(/* assignMessage(data?.message, language?.language) */data?.message)
                }
                else {
                    setSpin({})
                    errorMessage(/* assignMessage(data?.message, language?.language) */data?.message)
                }
            })
            .catch((e) => {
                setSpin({})
                console.log('e', e)
                errorMessage(/* assignMessage(e?.message, language?.language) */e?.message)
            })
    }

    return (
        <div className="main">
            <div className="second-design-service-container">
                <div className="service-top-div">
                    <div>
                        <h1>{selectedLanguage?.txt_room}</h1>
                    </div>
                </div>
                <div className="appointment-form-container">
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={() => setShowForms(!showForms)} type="primary">{!showForms ? selectedLanguage?.txt_show_table : selectedLanguage?.txt_add_service}</Button>
                    </div>
                    {!showForms ?
                        <DoctorRoomFormComponent edit={editData} {...props} onCancel={() => { setEditData({}); setShowForms(!showForms) }} />
                        : <div className='new-layout-table-upper-div'>
                            <Table
                                style={{ marginTop: '10px' }}
                                className='new-layout-table'
                                scroll={{ x: 'auto', y: '550px' }}
                                columns={columns}
                                dataSource={myRoomsData || []}
                                pagination={{ hideOnSinglePage: true }}
                            />
                        </div>}
                </div>
            </div>
        </div>
    )
}

export default DoctorRoomForm